import React, { useState, useEffect, useContext } from "react";
import {Inputs, Message, FormValidator, Scrollable} from "coaz-ui";
import client from '../client';

const AddContextRole = ({params, submitRef, setLoading, setEnableSubmit}) => {
	const [contexts, setContexts] = useState([]);
	const [roles, setRoles] = useState([]);
	const [owner, setOwner] = useState(null);
	const [context, setContext] = useState(null);
	const [role, setRole] = useState(null);
	const minWidth = 240;
	const [inputWidth, setInputWidth] = useState(minWidth);
	const { request, getByReference, errorMessage } = client;

	const handleSubmit = async (e) => {
		if (!owner || !context || !role) return;

		try {
            const response = await request("POST", "ownercontextroles", null, {
				ownerReference: owner.ref.value,
				context: context,
				roleId: role.ref.id,
			});

            if (response && response.owner) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
	};

	const inputs = [
		{
			label: "Owner",
			type: "text",
			name: "owner",
			disabled: true,
			value: owner && owner.name ? owner.name : "",
			placeholder: "Enter name...",
		},
		{
			label: "Context",
			type: "select",
			options: () => {
				let options = [];
				contexts &&
					contexts.map((option, i) =>
						options.push(
							<option key={i}>
								{option}
							</option>,
						),
					);
				return options;
			},
			name: "context",
			disabled: !(contexts && contexts.length > 0),
			value: context? context : "",
			placeholder: "Context...",
			onChange: (e) => {
				let found = contexts.find((ctxt) => {
					return ctxt == e.target.value;
				});
				setContext(found);
			},
		},
		{
			label: "Role",
			type: "select",
			options: () => {
				let options = [];
				roles &&
					roles.map((option, i) =>
						options.push(
							<option key={i} value={option.name}>
								{option.name}
							</option>,
						),
					);
				return options;
			},
			name: "role",
			disabled: !(roles && roles.length > 0),
			value: role && role.name ? role.name : "",
			placeholder: "Role...",
			onChange: (e) => {
				let found = roles.find((rle) => {
					return rle.name == e.target.value;
				});
				setRole(found);
			},
		},
	];

	useEffect(() => {
		if (handleSubmit) {
			submitRef.current = { submit: handleSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		return () => {
			submitRef.current = null;
		};
	}, [handleSubmit]);

	useEffect(() => {
		if (!params || !params.ownerReference) return;
		(async () => {
			setLoading && setLoading(true);
			await getByReference(params.ownerReference)
				.then((response) => {
					if (response && response.ref) {
						setOwner(response);
					}
				})
				.catch((error) => {
					console.log(error);
				});

			await request("GET", "contexts")
				.then((response) => {
					if (response && response.length && response.length > 0) {
						setContexts(response);
						setContext(response[0]);
					} else {
						setContexts([]);
					}
				})
				.catch((error) => {
					setContexts([]);
				});
			await request("GET", "roles")
				.then((response) => {
					setLoading(false);
					if (response && response.length && response.length > 0) {
						setRoles(response);
						setRole(response[0]);
					} else {
						setRoles([]);
					}
				})
				.catch((error) => {
					setRoles([]);
				});
			setLoading && setLoading(false);
		})();
	}, []);

	return (
		<FormValidator>
			<div className='w-full h-auto shrink-0'>
				<Inputs
					inputs={inputs}
					minWidth={minWidth}
					paddingX={0}
					spaceX={32}
					id="add_context_role"
					setCalcWidth={setInputWidth}
				/>
			</div>
		</FormValidator>	
	);
};

export default AddContextRole;
